import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { ThemeService } from '../services/theme.service';
import { VersionService } from '../services/version.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, MatSlideToggleModule, MatButtonModule],
})
export class SettingsComponent implements OnInit {
  storedVersion: string = '';
  apiVersion: string = '';

  constructor(public themeService: ThemeService, private versionService: VersionService) {}

  ngOnInit() {
    this.storedVersion = this.versionService.getStoredVersion();
    this.versionService.getApiVersion().subscribe({
      next: v => this.apiVersion = v,
      error: () => this.apiVersion = 'unavailable'
    });
  }

  async forceClearCache() {
    try {
      localStorage.removeItem('app-version');
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
      }
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map(r => r.unregister()));
      }
    } catch (e) {
      console.error('Error clearing cache', e);
    }
    window.location.replace(`/?_hard_refresh=${Date.now()}`);
  }
}
